import _ from "underscore";
import TemplateView from "./TemplateView";
import ScrollUtils from "./util/ScrollUtils";
import {fixIScrollInnerWheelEvent, isIE8} from "./atBrowserUtils"

function ScrollView($containerEl, itemHeight)
{
    TemplateView.call(this, $containerEl);
    this.itemHeight = itemHeight;
}

ScrollView.SHOW_EXTRA = 5;

ScrollView.prototype = _.create(TemplateView.prototype, {
    html: "<div class='scrollView scrollableContainer'>" +
          "  <div class='innerContainer'>" +
          "    <div class='placeholder top'></div>" +
          "    <div class='itemsContainer'></div>" +
          "    <div class='placeholder bottom'></div>" +
          "  </div>" +
          "</div>",

    afterRender: function()
    {
        var self = this;
        this.items = [];
        this._lastStartIndex = -1;
        this._lastEndIndex = -1;
        this._height = this.$el.height();

        this.$topPlaceholder = this.find(".placeholder.top");
        this.$bottomPlaceholder = this.find(".placeholder.bottom");
        this.$itemsContainer = this.find(".itemsContainer");

        this.verticalScroll = ScrollUtils.addVerticalScroll(this.$el, {probeType: 2});
        if (!isIE8())
        {
            this.verticalScroll.on("scroll", function()
            {
                self.updateScrollPosition();
                self.update();
                self.onScroll();
            });
        }
        else
        {
            this.$el.scroll(function()
                            {
                                self._scrollPosition = self.$el.scrollTop();
                                self._maxScrollPosition = self.$el[0].scrollHeight;
                                self.update();
                            });
        }

        fixIScrollInnerWheelEvent(this.getEl())
    },

    update: function()
    {
        var position = this._scrollPosition || 0;
        var itemHeight = this.itemHeight;
        var showCount = Math.ceil(this._height / itemHeight);
        var margin = ScrollView.SHOW_EXTRA;

        var startIndexWithoutMargin = Math.floor(position / itemHeight);
        var visibleEndIndex = Math.floor((position + this._height) / itemHeight);
        if (visibleEndIndex > this.items.length - 1) visibleEndIndex = this.items.length - 1;
        var endIndexWithoutMargin = startIndexWithoutMargin + showCount;
        if (endIndexWithoutMargin > this.items.length - 1) endIndexWithoutMargin = this.items.length - 1;

        if (this._updatedOnce && startIndexWithoutMargin >= this._lastStartIndex && visibleEndIndex <= this._lastEndIndex)
            return;

        this._updatedOnce = true;

        var startIndex = startIndexWithoutMargin - margin;
        if (startIndex < 0) startIndex = 0;
        if (startIndex > this.items.length - 1) startIndex = this.items.length - 1;
        var endIndex = endIndexWithoutMargin + margin;
        if (endIndex > this.items.length - 1) endIndex = this.items.length - 1;

        var topHeight = startIndex * itemHeight;
        var bottomHeight = (this.items.length - endIndex - 1) * itemHeight;

        this.$topPlaceholder.height(topHeight);
        this.$bottomPlaceholder.height(bottomHeight > 0 ? bottomHeight : 0);

        this.$itemsContainer.empty();
        for (var i = startIndex; i <= endIndex && i >= 0; i++)
            this.items[i].init(this.$itemsContainer);

        this._lastStartIndex = startIndex;
        this._lastEndIndex = endIndex;
    },

    getItems: function()
    {
        return this.items;
    },

    setItems: function(items)
    {
        this._updatedOnce = false;
        this.items = items;

        // TODO: make more optimal update here, full update happens twice
        this.update();
        this.refreshScroll();
    },

    scrollTo: function(y)
    {
        if (y < 0) y = 0;
        if (y > this._maxScrollPosition) y = this._maxScrollPosition;

        if (!isIE8())
            this.verticalScroll.scrollTo(0, -y);
        this._scrollPosition = y;
        this.update();
    },

    scrollToTop: function()
    {
        this.scrollTo(0);
    },

    scrollToItem: function(item)
    {
        var index = this.items.indexOf(item);
        if (index >= 0)
        {
            index -= ScrollView.SHOW_EXTRA - 1;
            this.scrollTo(this.itemHeight * index);
        }
    },

    refreshScroll: function()
    {
        this._height = this.$el.height();
        ScrollUtils.refreshCustomScroll(this.verticalScroll);
        this.updateScrollPosition();
        this.update();
    },

    updateScrollPosition: function()
    {
        if (!isIE8())
        {
            this._scrollPosition = -this.verticalScroll.y;
            this._maxScrollPosition = -this.verticalScroll.maxScrollY;
        }
    },

    adjustHeightToWindowSize: function()
    {
        this.$el.adjustHeightToWindowSize();
        this.refreshScroll();
    },

    onScroll: function(position, maxPosition)
    {
        // Abstract
    },

    isEmpty: function() {
        return this.items.length === 0;
    }
});

export default ScrollView;


// WEBPACK FOOTER //
// ./web/js/ScrollView.js